import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProgressBarService {
  private stepSubject = new BehaviorSubject<number | null>(null);
  public step$ = this.stepSubject.asObservable();

   /**
   * Zeigt die Progressbar und setzt den aktuellen Schritt.
   */
  show(step: number) {
    this.stepSubject.next(step);
  }

   /**
   * Versteckt die Progressbar.
   * Setzt den Status auf null.
   */
  hide() {
    this.stepSubject.next(null);
  }
}
